import { useCallback, useEffect, useState } from 'react';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { GridCellProps } from '@progress/kendo-react-grid';

const useDelayedInputOnchange = (cellProps: GridCellProps, isString = false) => {
  const { dataItem, field = '', onChange, dataIndex } = cellProps;

  const [value, setValue] = useState<string>(dataItem[field]?.toString() || '');
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setValue(dataItem[field]?.toString() || '');
  }, [dataItem, field]);

  const handleChange = useCallback(
    (e: TextBoxChangeEvent) => {
      const newValue = e.value as any;

      setValue(newValue);

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      const newTimeoutId = setTimeout(() => {
        onChange?.({
          dataIndex,
          dataItem,
          field,
          syntheticEvent: e.syntheticEvent,
          value: isString || newValue === '' ? newValue : +newValue,
        });
      }, 500);

      setTimeoutId(newTimeoutId);
    },
    [dataIndex, dataItem, field, isString, onChange, timeoutId]
  );

  return { handleChange, value };
};

export default useDelayedInputOnchange;
